import { render } from "./manage-fact.vue?vue&type=template&id=4d27b25c"
import script from "./manage-fact.vue?vue&type=script&lang=js"
export * from "./manage-fact.vue?vue&type=script&lang=js"

import "./manage-fact.vue?vue&type=style&index=0&id=4d27b25c&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__